var map = {
	"./background--1.jpg": 401,
	"./background--2.jpg": 402,
	"./background--3.jpg": 403,
	"./background--4.jpg": 404,
	"./background--5.jpg": 405,
	"./background--6.jpg": 406,
	"./icon-heart-fill.svg": 407,
	"./icon-heart-outline.svg": 408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 400;